module.exports = __webpack_public_path__ + "static/media/ESTRES_POR_CALOR_BANNER.d08a00d4.png";